import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';




const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}


function disabledDate(current) {
  // Can not select days before today and today
   return current && current > moment().endOf('day');
}


function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function yearDiff(dt1, dt2) 
 {
 
  var diffYear =(dt2.getTime() - dt1.getTime()) / 1000;
   diffYear /= (60 * 60 * 24);
  return Math.abs(Math.round(diffYear/365.25));
   
 }

class Login2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			
			loading: false,
			city_list: [],
			state_list: [],
			academic_year_: [],
			manage_class: [],
			school_details: [],
			user_id: '00',
			name: '',
			assign_label: 'Open',
			primary_mobile: '',
			secondary_mobile: '',
			email: '',
			locality: '',
			state: '',
			city: '',
			relation: '',
			child_name: '',
			gender: '',
			birthday: '',
			age: '',
			program_intrested: '',
			notes: '',
			date_of_enquiry: '',
			follow_up_date: '',
			how_know: '',
			academic_year: '',
			currentDate: '',
			is_important: 0,
			sms: 0,
			charLimit: 10,
			place_search: [],
			tag_name: [],
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.onChangebirthday = this.onChangebirthday.bind(this);	
		this.onChangejoin = this.onChangejoin.bind(this);	
		this.change_blood_group = this.change_blood_group.bind(this);	
		this.change_label = this.change_label.bind(this);	
		this.change_gender = this.change_gender.bind(this);	
		this.change_relation = this.change_relation.bind(this);	
		this.change_program = this.change_program.bind(this);	
		this.change_how_know = this.change_how_know.bind(this);	
		this.change_year = this.change_year.bind(this);	
		this.onChangeenquiry = this.onChangeenquiry.bind(this);	
		this.onChangefollow = this.onChangefollow.bind(this);	
		this.goBack = this.goBack.bind(this);	
		
		this.handleSubmit = this.handleSubmit.bind(this);
	
		this.change_state = this.change_state.bind(this);	
		this.change_city = this.change_city.bind(this);	
		this.handlesms = this.handlesms.bind(this);	
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		
		this.setState({ id : this.props.match.params.id, });
		
		
		
		var date = new Date();
		var  currentDate = date.getFullYear() + "-" + (date.getMonth()) + "-" + date.getDate();
		this.setState({ currentDate : currentDate });
		
		this.checkData();
		
		
	}
	
	onGetPlaceList = (e) => {
		var app = {search : e.target.value}
		getData('auth/place_search',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						place_search: result['data'],
					});
				}else{
					this.setState({
						place_search: [],
					});
				}
			}
		});
	}
	
	onSetPlace = (title,lat,lng) => {
		const $ = window.$;
		document.getElementById('search_latitude').value = lat;
		document.getElementById('search_longitude').value = lng;
		document.getElementById('search_addr').value = title;
		document.getElementById('search_location').value = title;
		this.setState({locality:title,place_search:[]});
	}
	
	checkData(){
  	    
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = this.state.user_id;
			var school_id = this.props.match.params.id;
			var type = 8;
			var app = {school_id : school_id,user_id:user_id,type:type}
			getData('highschool/state_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							state_list: result['data'],
						});
					}else{
						this.setState({
							state_list: [],
						});
					}
				}
			});	
			
			getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
						});
					}else{
						this.setState({
							academic_year_: [],
							
						});
					}
				}
			});	
			getData('erp/program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							manage_class: result['data'],
						});
					}else{
						this.setState({
							manage_class: [],
							
						});
					}
				}
			});	
			getData('erp/school_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_details: result['data'],
						});
					}else{
						this.setState({
							school_details: [],
							
						});
					}
				}
			});
			getData('erp/tag_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							tag_name: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							tag_name: '',
							
						});
					}
				}
			});
  }
  
  change_state(event){
         this.setState({state: event});
		 var app = {user_id : this.state.user_id,state_id:event}
			getData('highschool/city_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							city_list: result['data'],
						});
					}else{
						this.setState({
							city_list: [],
						});
					}
				}
			});		
		 
    }
	
	change_city(event){
         this.setState({city: event});
    }
	
	onChangebirthday(date, dateString) {
	  var dt1 = new Date(this.state.currentDate);
	  var dt2 = new Date(dateString);
      var year_differnece = yearDiff(dt1, dt2);	
	
	  this.setState({ birthday: dateString,age: year_differnece });
	}
	
	onChangeenquiry(date, dateString) {
	  this.setState({ date_of_enquiry: dateString });
	}
	
	onChangefollow(date, dateString) {
	  this.setState({ follow_up_date: dateString });
	}
	
	onChangejoin(date, dateString) {
	  this.setState({ date_of_enquiry: dateString });
	}
	
	change_gender(event){
         this.setState({gender: event});
     }
	 
	 change_label(event){
         this.setState({assign_label: event});
     }
	 
	 change_relation(event){
         this.setState({relation: event});
     }
	 
	  change_program(event){
         this.setState({program_intrested: event});
     }
	 
	  change_how_know(event){
         this.setState({how_know: event});
     }
	 
	  change_year(event){
         this.setState({academic_year: event});
     }
	 
	change_blood_group(event){
         this.setState({blood_group: event});
     }
	
	
	handleSizeChange = e => {		
		this.setState({ [e.target.name]: e.target.value });		
		if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
		if(e.target.name == 'email'){
			 var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			 if (pattern.test(e.target.value)) {
				document.getElementById("email_error").innerHTML = "";
				document.getElementById("submit_btn").disabled = false;
			  }else{
				document.getElementsByName(e.target.name)[0].classList.add("error_focus");
				document.getElementById("email_error").innerHTML = "Please Enter Valid Email !!!";
				document.getElementById("submit_btn").disabled = true;
			  }
		}
		if(e.target.name == 'primary_mobile'){
			 var pattern = new RegExp(/^[0-9\b]+$/);
			 if (!pattern.test(e.target.value)) {
				document.getElementsByName(e.target.name)[0].classList.add("error_focus");
				document.getElementById("mob_error").innerHTML = "Please Enter Only Number !!!";
				document.getElementById("submit_btn").disabled = true;
			  }else if(e.target.value.length != 10){
				document.getElementsByName(e.target.name)[0].classList.add("error_focus");
				document.getElementById("mob_error").innerHTML = "Please Enter Valid Phone Number. !!!";
				document.getElementById("submit_btn").disabled = true;
			  }else{
				document.getElementById("mob_error").innerHTML = "";
				document.getElementById("submit_btn").disabled = false;
			  }
		}
		
		if(e.target.name == 'secondary_mobile'){
			 var pattern = new RegExp(/^[0-9\b]+$/);
			 if (!pattern.test(e.target.value)) {
				document.getElementsByName(e.target.name)[0].classList.add("error_focus");
				document.getElementById("mob_error_1").innerHTML = "Please Enter Only Number !!!";
			  }else if(e.target.value.length != 10){
				document.getElementsByName(e.target.name)[0].classList.add("error_focus");
				document.getElementById("mob_error_1").innerHTML = "Please Enter Valid Phone Number. !!!";
			  }else{
				document.getElementById("mob_error_1").innerHTML = "";
			  }
		}	
	 };
	  
	handlesms = e => {
		//alert(e.target.value);
		this.setState({ sms : e.target.value });
	  };
	  
	  handleSubmit=(e)=>{
		e.preventDefault();
		
		this.setState({ loading: true });
		
		var address   = document.getElementById('search_addr').value;
		var latitude  = document.getElementById('search_latitude').value;
		var longitude = document.getElementById('search_longitude').value;
		
		var app = {
			first_name : this.state.first_name,
			last_name : this.state.last_name,
			assign_label : this.state.assign_label,
			user_id : this.state.user_id,
			school_id : this.props.match.params.id,
			primary_mobile : this.state.primary_mobile,
			secondary_mobile : this.state.secondary_mobile,
			email : this.state.email,
			locality : address,
			latitude : latitude,
			longitude : longitude,
			state : this.state.state,
			city : this.state.city,
			relation : this.state.relation,
			child_first_name : this.state.child_first_name,
			child_last_name : this.state.child_last_name,
			gender : this.state.gender,
			birthday : this.state.birthday,
			program_intrested : this.state.program_intrested,
			how_know : this.state.how_know,
			academic_year : this.state.academic_year,
			sms : this.state.sms,
		}
		getData('erp/add_enquiry',app).then((result) => {
		if(result.status==400){
             message.config({ top: 150});
			message.error(result.message,2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Your form has been submitted & fill another enquiry.',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
             window.location.reload(false);
              //this.checkdata();

          }
      });
	 

  }
  
  
  
  
  
  
	goBack(){
		window.location.href = '/admissions/enquiries';
	}
  
  

	render()

	{
	
	const { size } = this.state;
	
					
		return (
		<>
				
		
		<div class=" w-100">
			
		<div id="main" class="bg-off">
         <div class="row">
		 
		 
            
            <div class="col col-md-12  ex-padd">
			<div class="container view-Profile child-profile">
				<div class="page-header">
					<div class="row">
						<div class="col-md-12">
							{this.state.school_details.map((list) => (	
							 <div class="col col-md-12   pt-10 text-center">
								<h5 class="qr-header mb-0">{list.name}</h5>
								<h6 class="">{list.address}, {list.city} </h6>
							 </div>
							 ))}
								
						</div>
					</div>
				</div>
			   <div class="col col-md-12  mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-2  iq-card2 flow-root">
                     
						<div class="bb">
						  
						  <div class="col col-md-12 s12 no-padd form-group">
								<div class="row">
								
								
								<div class="col-md-6  mt-10  mb-20 ">
									<label>First Name</label>
									<input type="text" class="form-control"  name="first_name" onChange={this.handleSizeChange}   required/>
									
								</div>	
								<div class="col-md-6  mt-10  mb-20 ">
									<label>Last Name</label>
									<input type="text" class="form-control"  name="last_name" onChange={this.handleSizeChange}   required/>
									
								</div>	
								<div class="col-md-6 mt-10 mb-20">
									<label>Assign Label</label>
									<Select onChange={this.change_label} value={this.state.assign_label} disabled>
										{this.state.tag_name.map((list)=>(
										<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
									</Select>
								</div>	
								
								<div class="col-md-6  mb-20">
									<label>Primary Mobile</label>
									<input type="number" class="form-control" pattern="[0-9]*" maxlength="10" name="primary_mobile" onChange={this.handleSizeChange}   required/>
									<span class="error" id="mob_error" ></span>
								</div>
								<div class="col-md-6  mb-20">
									<label>Secondary Mobile</label>
									<input type="number" class="form-control" pattern="[0-9]*" name="secondary_mobile" onChange={this.handleSizeChange}   required/>
									<span class="error" id="mob_error_1" ></span>
								</div>
								
								<div class="col-md-6  mb-20">
									<label>Email</label>
									<input type="text" class="form-control" class="form-control"  name="email" onChange={this.handleSizeChange}   required/>
									<span class="error" id="email_error" ></span>
								</div>
								<div class="col-md-6  mb-20">
									<label>Locality</label>
									 <input type="text" class="form-control"  id="search_location" name="locality" onChange={this.onGetPlaceList}   required/>
									 <input type="text" defaultValue={this.state.search_latitude} class="hide" id="search_latitude" readOnly/>
									 <input type="text" defaultValue={this.state.search_longitude} class="hide" id="search_longitude" readOnly/>
									 <input type="text" defaultValue={this.state.search_addr} class="hide" id="search_addr" readOnly/>
									 
									 {(() => {
									   if (this.state.place_search.length>0 ) {
									   return (
										<>
											<div class="place-list">
											<ul>
											{this.state.place_search.map((data) => (
											<>
												<li onClick={this.onSetPlace.bind(this,data.title,data.lat,data.lng)}>{data.title}</li>
											</>
											))}
											</ul>
											</div>
										</>
									   )	
									 }
									})()}
									 
								</div>
								<div class="col-md-6  mb-20">
									<label>State</label>
									<Select onChange={this.change_state} class="error_focus" showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
										{this.state.state_list.map((list) => (	
										<Select.Option value={list.id}>{list.name}</Select.Option>
										))}
									</Select>
								</div>
								<div class="col-md-6  mb-20">
									<label>City</label>
									<Select onChange={this.change_city} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
										{this.state.city_list.map((list) => (	
										<Select.Option value={list.id}>{list.name}</Select.Option>
										))}
									</Select>
								</div>
								<div class="col-md-6 mb-20">
									<label>Relation With Child</label>
									<Select onChange={this.change_relation}>
										<Select.Option value="Father">Father</Select.Option>
										<Select.Option value="Mother">Mother</Select.Option>
										<Select.Option value="Guardian">Guardian</Select.Option>
									</Select>
								</div>
								
								<div class="col-md-6  mb-20">
									<label>Child First Name</label>
									<input type="text" class="form-control"  name="child_first_name" onChange={this.handleSizeChange}   required/>
								</div>
								<div class="col-md-6  mb-20">
									<label>Child Last Name</label>
									<input type="text" class="form-control"  name="child_last_name" onChange={this.handleSizeChange}   required/>
								</div>
								<div class="col-md-4 mb-20">
									<label>Gender</label>
									<Select onChange={this.change_gender}>
										<Select.Option value="Male">Male</Select.Option>
										<Select.Option value="Female">Female</Select.Option>
										<Select.Option value="Other">Other</Select.Option>
									</Select>
								</div>								
														
								<div class="col-md-4 mb-20">
									<label>Birthday</label>
									<DatePicker onChange={this.onChangebirthday} disabledDate={disabledDate} />
								</div>	
								<div class="col-md-4 mb-10">
									<label>Age</label>
									<input type="text" class="form-control"  name="age" onChange={this.handleSizeChange}  value={this.state.age} disabled/>
								</div>
								<div class="col-md-4 mb-20">
									<label>Program Interested</label>
									<Select onChange={this.change_program}>
											{this.state.manage_class.map((list) => (
													<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
									</Select>
								</div>
								
								
								<div class="col-md-4 mb-20">
									<label>How you got to know about us?</label>
									<Select onChange={this.change_how_know}>
										<Select.Option value="Apartment event">Apartment event</Select.Option>
										<Select.Option value="Banner">Banner</Select.Option>
										<Select.Option value="Digital Ads">Digital Ads</Select.Option>
										<Select.Option value="Facebook">Facebook</Select.Option>
										<Select.Option value="Field data">Field data</Select.Option>
										<Select.Option value="Flayers">Flayers</Select.Option>
										<Select.Option value="No parking board">No parking board</Select.Option>
										<Select.Option value="Perent referral">Perent referral</Select.Option>
										<Select.Option value="Pole Kiosk">Pole Kiosk</Select.Option>
										<Select.Option value="Poster Ads">Poster Ads</Select.Option>
										<Select.Option value="Staff referral">Staff referral</Select.Option>
										<Select.Option value="Store activity">Store activity</Select.Option>
										<Select.Option value="Walk In">Walk In</Select.Option>
										<Select.Option value="Website">Website</Select.Option>
									</Select>
								</div>
								
								<div class="col-md-4 mb-20 pb-20">
									<label>Academic Year</label>
									<Select onChange={this.change_year}>	
									 <Select.Option value="">Select Academic Year</Select.Option>
										{this.state.academic_year_.map((list) => (
											<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
									</Select>
								</div>	
								
								
								</div>	
															
						  </div>
						</div>
							
						
					</div> 
					
						
					
					
					<div class="col col-md-12 s12 meal mb-20 pb-20 bb text-center">
						 <Button className="btn btn-primary" onClick={this.handleSubmit} loading={this.state.loading}>Submit</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
			</>
		) 
	} 
}
export default Login2;
